// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,html{height:100%;overflow-x:auto;overflow-y:auto}html::-webkit-scrollbar{display:none}.crawler-web-app__window--min-size{min-width:900px;min-height:500px}", ""]);
// Exports
module.exports = exports;
